import { createContext, type ReactNode } from "react";
import { useFeatureSettings } from "../use-feature-settings";

export const ImageValidationRenderingContext = createContext(false);

/** One feature-setting subscription per root; no DOM or user-facing controls. */
export function ImageValidationRenderingProvider({ children }: { readonly children: ReactNode }): JSX.Element {
    const [enabled] = useFeatureSettings(["imageValidationClient"]);
    return (
        <ImageValidationRenderingContext.Provider value={enabled}>{children}</ImageValidationRenderingContext.Provider>
    );
}
